import React, { useState } from 'react';
interface AccordionItemProps {
  title: string;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  children: React.ReactNode;
}

interface AccordionContent {
  lable: string;
  content: string | React.ReactNode;
}

interface AccordionProps {
  items: AccordionContent[];
}

/** AccordionItem Component */
const AccordionItem: React.FC<AccordionItemProps> = ({ title, isOpen, setIsOpen, children }) => (
  <div className='border border-[#552B18] rounded-2xl w-full'>
    <div className='flex justify-between items-center px-4 py-2 cursor-pointer' onClick={() => setIsOpen(!isOpen)}>
      <span className='font-poppins font-semibold text-base sm:text-base md:text-lg lg:text-lg'>{title}</span>
      <svg
        className={`w-5 h-5 transform transition-transform duration-300 ${isOpen ? 'rotate-180' : 'rotate-0'}`}
        fill='none'
        stroke='currentColor'
        viewBox='0 0 24 24'
      >
        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M19 9l-7 7-7-7' />
      </svg>
    </div>
    {isOpen && <div className='px-4 pb-4 text-sm sm:text-sm md:text-base lg:text-base'>{children}</div>}
  </div>
);

/**  Main Accordion Component */
const ProductAccordion: React.FC<AccordionProps> = ({ items }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className='flex flex-col gap-4  max-w-lg md:w-auto font-poppins'>
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          title={item.lable}
          isOpen={openIndex === index}
          setIsOpen={() => handleToggle(index)}
        >
          {item.content}
        </AccordionItem>
      ))}
    </div>
  );
};

export default ProductAccordion;
